import { merge } from '@inpart-io/devtools';
import { type IUserTenantAccess } from '@inpart-io/devtools-iap';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { userTenantAccessesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { type IUserState } from '@/store/user-profile-module/types';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const USER_TENANT_ACCESS_MODULE = 'userTenantAccess';

const state: IUserState = {
    byUser: new Map(),
    all: []
};

const dataObjectModule = getDataObjectsModule<IUserTenantAccess>(userTenantAccessesManager);
const userTenantAccessModuleInstance = merge<unknown>(dataObjectModule, { state, actions, getters, mutations });
store.registerModule(USER_TENANT_ACCESS_MODULE, userTenantAccessModuleInstance);

export { USER_TENANT_ACCESS_MODULE };
